// shopline希望不受48小时限制，方便测试 source from JJ
export const whiteList = [
  ' bing@shopline.com',
  'willie@shopline.com',
  'lanhuichi@shopline.com',
  '15800235533',
  '8615800235533',
  '+8615800235533',
  'wumin@seel.com',
];
